import type { Hydratable } from '@vimcar/mvvm/hydratable'

import * as dataMapper from '@vimcar/mvvm/dataMapper'
import hydratable from '@vimcar/mvvm/hydratable'
import * as mobx from 'mobx'

import type { Nodes, ContentType } from '../'
import type { CustomNode } from '../CustomNode'
import type { KeyValuePair } from '../KeyValuePair'
import type { SelectNode } from '../SelectNode'

export type Values = {
  destination?: string
  group?: number
  subject?: string
  priority?: string
  team?: string
  tags?: Array<string>
  pipedriveId?: number
  stageId?: number
  // @ts-expect-error@2314
  attrs: mobx.ObservableMap<string, string>
}

type _ValuedNode = {
  id: string
  title: string
  _baseNode: { sys: { id: string } }
  _attributes?: Array<{ sys: { id: string } }> | null
  contentModelType: ContentType
  baseNode: SelectNode | CustomNode
  attributes: Array<KeyValuePair>
} & Values
// @ts-expect-error@2314
export type ValuedNode = Hydratable<_ValuedNode, object>

type Options = { nodes: Nodes }

const mkValuedNode = hydratable(
  ({ nodes }: Options) => {
    const valuedNode = mobx.observable({
      contentModelType: 'valuedNode',
      get baseNode() {
        return valuedNode._baseNode && nodes.get(valuedNode._baseNode.sys.id)
      },
      get attributes() {
        return (
          valuedNode._attributes &&
          nodes.keyValuePairs
            .values()
            .filter((pair) =>
              valuedNode._attributes.some((ref) => ref.sys.id === pair.id),
            )
        )
      },
    } as _ValuedNode)
    return valuedNode
  },
  'ValuedNode',
  {
    fields: dataMapper.lift({
      baseNode: '_baseNode',
      attrs: '_attributes',
    }),
    sys: dataMapper.lift({
      id: true,
    }),
  },
)

export default mkValuedNode
